import axios from "axios";

export let axiosClient = () => {
  let token = localStorage ? localStorage.getItem("token") ?? "" : "";
  return axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: {
      Authorization: token,
    },
  });
};

export default axiosClient;
